import React, { Component, PropTypes } from 'react';
import styleable from 'react-styleable';
import defaultStyle from './paged-list.style';
import PagingControl from './paging-control';
import { LoadingPane } from '../common';

export class PagedList extends Component {

  render() {
    const { header, items, mapItem, emptyMessage, isLoading,
      currentPage, resultsPerPage, variableResultsPerPage, perPageOptions,
      totalItemsCount, changePageNumber, changeResultsPerPage,
      css, loadingMessage, contentLoadedMessage } = this.props;

    return(
      <div>
        <table id="summary-table" className={css.table}>
          <thead>
            {header}
          </thead>
          <LoadingPane
            isLoading={isLoading}
            loadingMessage={loadingMessage}
            contentLoadedMessage={contentLoadedMessage}
            type='tbody'>
            {items.length > 0 ? items.map(item => (
              mapItem(item)
            )) : <div id="emptyMessage">{emptyMessage}</div>}
          </LoadingPane>
        </table>
        {!isLoading ?
          <PagingControl
            resultsPerPage={resultsPerPage}
            totalItemsCount={totalItemsCount}
            currentPage={currentPage}
            variableResultsPerPage={variableResultsPerPage}
            perPageOptions={perPageOptions}
            changeResultsPerPage={changeResultsPerPage}
            changePageNumber={changePageNumber} />
            : null}
      </div>
    );
  }
}

PagedList.defaultProps = {
  loadingMessage : 'Loading...',
  contentLoadedMessage : 'Content Loaded'
}

PagedList.propTypes = {
  header: PropTypes.element.isRequired,
  items: PropTypes.array.isRequired,
  emptyMessage: PropTypes.element,
  loadingMessage: PropTypes.string,
  contentLoadedMessage: PropTypes.string,
  mapItem: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  changePageNumber: PropTypes.func,
  changeResultsPerPage: PropTypes.func,
  variableResultsPerPage: PropTypes.bool,
  perPageOptions: PropTypes.array, // expects an array with objects containing a number 'value' and a string 'label'
  isLoading: PropTypes.bool.isRequired,
};

export default styleable(defaultStyle) (PagedList);



// WEBPACK FOOTER //
// src/common/paged-list.js